export default class ToggleFilterTrays {
    filterTrays: NodeListOf<HTMLElement>;

    constructor(container: HTMLElement) {
        this.filterTrays = container.querySelectorAll(".search-filter-tray") as NodeListOf<HTMLElement>;
        this.initialise();
    }

    initialise = () => {
        for (let i = 0; i < this.filterTrays.length; i++) {
            const filterTray = this.filterTrays[i];
            const title = filterTray.querySelector(".search-filter__title") as HTMLInputElement;
            const inner = filterTray.querySelector(".search-filter__inner") as HTMLElement;

            if (title.classList.contains("search-filter__title--sub-menu")) {
                title.addEventListener("click",
                    () => {
                        filterTray.classList.remove("is-active");
                    });
                title.addEventListener("keyup",
                    (e) => {
                        if (e.key === "Space") {
                            filterTray.classList.remove("is-active");
                        }
                    });
            } else {
                title.addEventListener("click",
                    () => {
                        this.toggleTrayOpenClose(title, inner);
                    });
                title.addEventListener("keyup",
                    (e) => {
                        if (e.key === "Space") {
                            this.toggleTrayOpenClose(title, inner);
                        }
                    });
            }

            //configure filter toggle click events
            const filterToggles = filterTray.querySelectorAll(".filter-toggle") as NodeListOf<HTMLElement>;;
            const selectLists = filterTray.querySelectorAll(".search-select-list") as NodeListOf<HTMLElement>;;

            for (let x = 0; x < filterToggles.length; x++) {
                const filterToggle = filterToggles[x];
                const selectList = selectLists[x];
                const inputs = filterToggle.getElementsByTagName('input');

                for (let a = 0; a < inputs.length; a++) {
                    const checkbox = inputs[a];

                    if (checkbox.type === "radio") {
                        checkbox.addEventListener("click", () => {
                            this.toggleFilterList(checkbox, selectList, selectLists);
                        });
                        checkbox.addEventListener("keyup", (e: any) => {
                            if (e.key === "Enter" || e.key === "Space") {
                                this.toggleFilterList(checkbox, selectList, selectLists);
                            }
                        });
                    }
                }
            }
        }
    }

    toggleTrayOpenClose = (title: any, inner: any) => {
        title.classList.toggle("search-filter__title--open");
        inner.classList.toggle("search-filter__inner--open");
    }

    toggleFilterList = (checkbox: any, selectList: any, otherSelectLists: any) => {
        for (let b = 0; b < otherSelectLists.length; b++) {
            otherSelectLists[b].style.display = "none";
        }

        if (checkbox.checked) {
            selectList.style.display = "block";
        }
    }
}
